import api from './api';

/**
 * @returns {Promise<{
 *  test_centre_number: string
 *  legacy_number: string
 * }[]>}
 */
export default async function getTestCentreAndLegacy(level_id) {
    const { data } = await api.get(`levels/${level_id}/candidate_numbers`);

    return data;
}